import { Accept } from 'components/Accept/Accept';
import { NOOP } from 'constants/actions';
import { useTranslations } from 'utils/translations/useTranslations';
import { AstropayConditions } from './components/AstropayConditions/AstropayConditions';
import { PrivacyPolicyLink } from './components/PrivacyPolicyLink/PrivacyPolicyLink';
import { RecurringTermsLink } from './components/RecurringTermsLink/RecurringTermsLink';
import { TermsOfUseLink } from './components/TermsOfUseLink/TermsOfUseLink';

function Space({ content = ' ' }: { content?: string }) {
  return <span>{content}</span>;
}

interface SinglePaymentProps {
  checked?: boolean;
  isOfferAstropay?: boolean;
  onChange?: () => void;
}

function SinglePayment({
  checked = false,
  isOfferAstropay = false,
  onChange = NOOP,
}: SinglePaymentProps) {
  const i18n = useTranslations();

  return (
    <Accept
      data-testid="terms-single-payment"
      name="checkbox-terms-conditions"
      className="PaymentOptions-terms"
      checked={checked}
      onChange={onChange}
    >
      {i18n.t('checkout.termsAndConditions.terms_read')}
      <Space />
      <TermsOfUseLink />
      <Space />
      {i18n.t('checkout.termsAndConditions.and')}
      <Space />
      <PrivacyPolicyLink />
      {isOfferAstropay && <AstropayConditions />}
    </Accept>
  );
}

interface RecurringPaymentProps {
  checked?: boolean;
  onChange?: () => void;
}

function RecurringPayment({
  checked = false,
  onChange = NOOP,
}: RecurringPaymentProps) {
  const i18n = useTranslations();

  return (
    <Accept
      name="checkbox-terms-conditions"
      className="PaymentOptions-terms"
      checked={checked}
      onChange={onChange}
    >
      {i18n.t('checkout.termsAndConditions.terms_read')}
      <Space />
      <TermsOfUseLink />
      <Space />
      {i18n.t('checkout.termsAndConditions.and')}
      <Space />
      <PrivacyPolicyLink />
      <Space content=", " />
      {i18n.t('checkout.termsAndConditions.and')}
      <Space />
      <RecurringTermsLink />
    </Accept>
  );
}

export function Terms() {
  return null;
}

Terms.displayName = 'Terms';
Terms.SinglePayment = SinglePayment;
Terms.RecurringPayment = RecurringPayment;
